import React from "react";
import Book from "../3D-Book/Book";
import "./About.css";
import Button from "../Button/Button";

const About = ({ theme }) => {
  return (
    <>
      <section className="about" id="about">
        {/* <figure className="about-banner">
          <img
            src="./assets/images/hero-banner3.png"
            alt="A man in a alice blue shirt with a thinking expression"
            className="w-100"
          />
        </figure> */}
        <Book />

        <div className="about-content section-content">
          <p className="section-subtitle">About me</p>

          <h2 className="h3 section-title">
            Know about me: Brief insights into my background and expertise.
          </h2>

          <div className="btn-group">
            {/* <a href="#contact" className="btn btn-secondary">
              Contact Me
            </a> */}

            <Button
              className={`${
                theme === "light_theme" ? "custom-btn btn-1" : "custom-btn btn-2"
              }`}
              href="https://drive.google.com/file/d/14vMN5OUiuzYxO5Q8-_w7-JboW2qB2ZqF/view?usp=drive_link"
            >
              Download CV
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
